export default {
  servers: {
    title: 'Servers'
  },
  events: {
    title: 'Latest events'
  },
  db_status: {
    title: 'DB status'
  }
}
